import { Avatar, Box, Button, TextField, Typography } from "@mui/material"
import styles from "./Signup.module.css"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import ShariLogo from "../../assets/images/shariehandslogo.png"
import Icn from "../UI/SharieIcn/SharieIcn"
import Spinner from "../UI/Spinner/Spinner"
import { useSrpAuth } from "../hooks/Api/useSrpLogin"
import useError from "../hooks/Error/useError"
import confetti from "canvas-confetti"

const Signup = () => {
  const [loading, setLoading] = useState(false)
  const [user_name, setUserName] = useState(null)
  const [password, setPassword] = useState(null)
  const { registerSrp } = useSrpAuth()
  const navigate = useNavigate()
  const t = useTranslationSharie()
  const { Error: AlertError, error, success } = useError()

  const doSignup = async () => {
    const user_regex = /^[a-zA-Z0-9_]{3,15}$/
    const password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/
    if (!user_name || !password) error(t("Must Fill All Fields"))
    else if (!user_regex.test(user_name))
      error(
        t(
          "User Name must be 3-15 characters long and can only contain letters, numbers, and underscores."
        )
      )
    else if (!password_regex.test(password))
      error(
        t(
          "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character."
        )
      )
    else {
      setLoading(true)
      try {
        const message = await registerSrp(user_name, password) // await here
        setLoading(false)

        if (message !== "Successful") {
          error(message)
        } else {
          confetti({
            particleCount: 100,
            spread: 70,
            origin: { y: 0.6 },
          })
          success("User Added Successfully!")
          setTimeout(() => {
            navigate("/")
          }, 3000)
        }
      } catch (error) {
        error("Registration failed, please try again.")
        setLoading(false)
      }
    }
  }

  const handleUserNameChange = (e) => {
    setUserName(e.target.value)
  }
  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  const inputKeyDown = (e) => {
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      doSignup()
    }
  }
  const goToLogin = () => {
    navigate("/")
  }
  return (
    <T>
      <Box className={styles.signup_box}>
        {/* Headline for Sharie */}
        <Box className={styles.headline_container}>
          <Icn
            label='logo'
            avatar={<Avatar src={ShariLogo} alt='Icon' className={"shari_logo"} />}
          />
          <Typography variant='h3' component='h1' className={styles.signup_headline}>
            Sharie
          </Typography>
        </Box>

        <Box
          component='form'
          onSubmit={(e) => e.preventDefault()} // Handle submit logic here
          sx={{
            width: "100%",
            maxWidth: 400,
            padding: 3,
            backgroundColor: "background.paper",
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          <TextField
            fullWidth
            label={t("User Name")}
            name='username'
            type='text'
            variant='outlined'
            margin='normal'
            required
            value={user_name}
            autoFocus
            onChange={(e) => {
              handleUserNameChange(e)
            }}
          />
          <TextField
            fullWidth
            label={t("Password")}
            name='password'
            type='password'
            variant='outlined'
            margin='normal'
            helperText={t(
              "Password must be a combination of uppercase, lowercase, number, and special character.6 characters minimum."
            )}
            required
            onKeyDown={inputKeyDown}
            onChange={(e) => {
              handlePasswordChange(e)
            }}
          />

          <Button
            fullWidth
            variant='contained'
            color='primary'
            type='submit'
            onClick={doSignup}
            sx={{ marginTop: 2 }}
            disabled={loading}
          >
            Signup
          </Button>
          <AlertError />
          <h1 className={styles.login_button} title='back to login' onClick={goToLogin}>
            {t("back to main page")}
          </h1>
        </Box>
      </Box>
      {loading && <Spinner />}
    </T>
  )
}

export default Signup
